module.exports = __webpack_public_path__ + "static/img/login-zhaopin-item-02.2c5e8bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/login-zhaopin-item-02.png
// module id = huHU
// module chunks = 4